var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/images/searchbg.png")}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("授权失败，无法进行医保在线结算")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":_vm.goPay}},[_vm._v("重新发起医保电子凭证授权")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed78856c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/empowerOver/empowerOver.vue
// module id = null
// module chunks = 